import { Expose, Transform } from 'class-transformer';

import { MessageType, UserGender, UserType } from '../../common';
import { Model } from './model';

export class MessagesReport extends Model {
  @Expose() count: number;
  @Expose() message: string;
  @Expose() read: number;
  @Expose() unRead: number;
  @Expose() type: MessageType;
  @Expose() userGender: UserGender;
  @Expose() userType: UserType;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  date?: Date | null;
}
